import { render, staticRenderFns } from "./SpecimenSurveyQueryResultTabularView.vue?vue&type=template&id=5986d442"
import script from "./SpecimenSurveyQueryResultTabularView.vue?vue&type=script&lang=js"
export * from "./SpecimenSurveyQueryResultTabularView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports